// import Carousel from 'react-bootstrap/Carousel';

// function ImageCarousel() {
//   return (
//     <Carousel>
//         <Carousel.Item interval={1500}>
//           <img
//             className="d-block w-100"
// src="https://media.geeksforgeeks.org/wp-content/uploads/20210425122739/2-300x115.png"
//             alt="One"
//           />
//           <Carousel.Caption>
//             <h3>Label for first slide</h3>
//             <p>Sample Text for Image One</p>
//           </Carousel.Caption>
//         </Carousel.Item>
//         <Carousel.Item interval={500}>
//           <img
//             className="d-block w-100"
// src="https://media.geeksforgeeks.org/wp-content/uploads/20210425122716/1-300x115.png"
//             alt="Two"
//           />
//           <Carousel.Caption>
//             <h3>Label for second slide</h3>
//             <p>Sample Text for Image Two</p>
//           </Carousel.Caption>
//         </Carousel.Item>
//       </Carousel>
//   );
// }

// export default ImageCarousel;

import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Maximize2, X } from "lucide-react";

// FULLY UPGRADED IMAGE CAROUSEL
// Features:
// ✔ Auto-scroll
// ✔ Manual arrows
// ✔ Dots indicator
// ✔ Scroll-snap horizontal track
// ✔ Touch swipe
// ✔ Framer-motion animations
// ✔ Fullscreen lightbox view
// ✔ Reusable component

export default function ImageCarousel() {
  const images = [
    "/images/t000.jpg",
    "/images/t0.jpg",
    "/images/t00.jpg",
    "/images/t6.jpg",
    "/images/t5.jpg",
    "/images/t1.jpg",
    "/images/t2.jpg",
    "/images/t3.jpg",
    "/images/t4.jpg",
  ];

  const [current, setCurrent] = useState(0);
  const [fullscreen, setFullscreen] = useState(false);
  const intervalRef = useRef(null);
  const containerRef = useRef(null);

  // Auto-scroll every 3 seconds
  useEffect(() => {
    startAutoScroll();
    return stopAutoScroll;
  }, [current]);

  const startAutoScroll = () => {
    stopAutoScroll();
    intervalRef.current = setInterval(() => {
      next();
    }, 6000);
  };

  const stopAutoScroll = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  const next = () => {
    setCurrent((prev) => (prev + 1) % images.length);
  };

  const prev = () => {
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  // Scroll to image when current changes
  useEffect(() => {
    if (containerRef.current) {
      const width = containerRef.current.clientWidth;
      containerRef.current.scrollTo({ left: current * width, behavior: "smooth" });
    }
  }, [current]);

  return (
    <div className="w-full py-6 select-none rounded-xl">
      {/* IMAGE CAROUSEL WRAPPER */}
      <div className="relative w-fit overflow-hidden rounded-xl">
        {/* Images track */}
        <div
          ref={containerRef}
          className="flex overflow-x-hidden snap-x snap-mandatory z-0 rounded-xl"
          style={{ scrollBehavior: "smooth" }}
        >
          {images.map((src, i) => (
            <div
              key={i}
              className="min-w-full h-64 md:h-80 snap-center relative cursor-pointer"
              onClick={() => setFullscreen(true)}
            >
              <motion.img
                src={src}
                alt={`Temple ${i + 1}`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="w-full h-full object-cover"
              />

              {/* Fullscreen icon */}
              <div className="absolute top-3 right-3 bg-black/40 p-2 rounded-full z-0">
                <Maximize2 className="text-white w-5 h-5" />
              </div>
            </div>
          ))}
        </div>

        {/* LEFT ARROW */}
        <button
          onClick={prev}
          className="absolute top-1/2 left-3 -translate-y-1/2 bg-black/40 hover:bg-black/60 p-2 rounded-full z-0"
        >
          <ChevronLeft className="text-white w-6 h-6" />
        </button>

        {/* RIGHT ARROW */}
        <button
          onClick={next}
          className="absolute top-1/2 right-3 -translate-y-1/2 bg-black/40 hover:bg-black/60 p-2 rounded-full"
        >
          <ChevronRight className="text-white w-6 h-6" />
        </button>
      </div>

      {/* DOT INDICATORS */}
      <div className="flex justify-center mt-4 gap-2">
        {images.map((_, i) => (
          <div
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-3 h-3 rounded-full cursor-pointer transition-all ${
              current === i ? "bg-orange-600 scale-125" : "bg-gray-400"
            }`}
          />
        ))}
      </div>

      {/* FULLSCREEN LIGHTBOX */}
      <AnimatePresence>
        {fullscreen && (
          <motion.div
            className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.img
              src={images[current]}
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              className="max-h-[90vh] max-w-[90vw] rounded-lg shadow-xl"
            />

            {/* Close button */}
            <button
              onClick={() => setFullscreen(false)}
              className="absolute top-6 right-6 bg-white/20 p-3 rounded-full"
            >
              <X className="text-white w-6 h-6" />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
